import React, { useMemo } from 'react';

export default function RevenueChart({ bookings }) {
    const data = useMemo(() => {
        const months = [];
        for (let i = 5; i >= 0; i--) {
            const d = new Date();
            d.setMonth(d.getMonth() - i);
            months.push({
                label: d.toLocaleString('default', { month: 'short' }),
                month: d.getMonth(),
                year: d.getFullYear(),
                revenue: 0
            });
        }

        (bookings || []).forEach(b => {
            // Include paid/completed bookings in the revenue calc
            if (['paid', 'completed', 'delivered', 'returned'].includes(b.status)) {
                const bDate = b.date ? new Date(b.date) : (b.createdAt?.seconds ? new Date(b.createdAt.seconds * 1000) : null);
                if (bDate) {
                    const mIndex = months.findIndex(m => m.month === bDate.getMonth() && m.year === bDate.getFullYear());
                    if (mIndex !== -1) {
                        months[mIndex].revenue += (b.totalCost || 0);
                    }
                }
            }
        });

        const maxRev = Math.max(...months.map(m => m.revenue), 100); // minimum 100 to avoid div by 0
        return months.map(m => ({ ...m, height: `${(m.revenue / maxRev) * 100}%` }));
    }, [bookings]);

    return (
        <div className="bg-white p-6 rounded-lg shadow-lg h-full border border-gray-100 flex flex-col">
            <h3 className="text-xl font-bold mb-4 text-gray-800">Revenue (Last 6 Months)</h3>
            <div className="flex-1 min-h-[200px] flex items-end justify-between gap-3 pt-8 border-b border-gray-100 pb-2">
                {data.map((item, i) => (
                    <div key={i} className="flex-1 flex flex-col items-center justify-end h-full group relative">
                        <span className="opacity-0 group-hover:opacity-100 absolute -top-10 bg-gray-900 text-white text-xs py-1.5 px-2.5 rounded whitespace-nowrap transition-opacity z-10 shadow-md pointer-events-none">
                            ${item.revenue.toFixed(2)}
                        </span>
                        <div className="w-full bg-pink-100 rounded-t-md relative hover:bg-pink-300 transition-colors cursor-pointer" style={{ height: item.height }}>
                            <div className="absolute bottom-0 left-0 right-0 bg-pink-500 rounded-t-md opacity-50" style={{ height: '10%', minHeight: '4px' }}></div>
                        </div>
                        <span className="text-xs text-gray-500 mt-3 font-medium uppercase tracking-wider">{item.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}